/**
 * CategoryButton Component Export
 * @module components/PlayerDetailRight/CategoryButton
 */

export { default } from "./CategoryButtonContainer";
